// ============================================================
// Provera PIB-a i matičnog broja (Srbija)
// PIB: 9 cifara, poslednja je kontrolna (ISO 7064, MOD 11,10)
// MB:  8 cifara, poslednja je kontrolna (MOD 11)
// ============================================================

export const digitsOnly = (v) => String(v || '').replace(/\D/g, '');

export function pibChecksumOk(pib) {
  if (!/^\d{9}$/.test(pib)) return false;
  let a = 10;
  for (let i = 0; i < 8; i++) {
    a = (a + Number(pib[i])) % 10;
    if (a === 0) a = 10;
    a = (a * 2) % 11;
  }
  return (11 - a) % 10 === Number(pib[8]);
}

export function mbChecksumOk(mb) {
  if (!/^\d{8}$/.test(mb)) return false;
  const w = [2, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 7; i++) sum += Number(mb[i]) * w[i];
  let r = 11 - (sum % 11);
  if (r > 9) r = 0;
  return r === Number(mb[7]);
}

// Vraća tekst greške ili '' ako je u redu. Prazno polje je dozvoljeno.
export function pibError(value) {
  const v = digitsOnly(value);
  if (!v) return '';
  if (v.length !== 9) return `PIB mora imati tačno 9 cifara (uneto ${v.length}).`;
  if (!pibChecksumOk(v)) return 'PIB nije ispravan: kontrolna cifra se ne slaže. Proverite da li je dobro prepisan.';
  return '';
}

export function mbError(value) {
  const v = digitsOnly(value);
  if (!v) return '';
  if (v.length !== 8) return `Matični broj mora imati tačno 8 cifara (uneto ${v.length}).`;
  if (!mbChecksumOk(v)) return 'Matični broj nije ispravan: kontrolna cifra se ne slaže. Proverite da li je dobro prepisan.';
  return '';
}
